export enum SubscriptionListTabsEnum {
  DRAFT = 'draft',
  OPEN = 'open',
  PAUSED = 'paused',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
  DELETED = 'deleted',
  TEMPLATE = 'template',
  ALL = 'all',
}
